import { Service } from '@angular/core';
import { map, Observable } from 'rxjs';
import { KalaApiResponse } from '../models/kala-api.model';
import { DepositPortfolioResponse } from '../models/portfolio-response.model';
import { BaseService } from './base.service';

/**
 * Reads the customer's deposit holdings.
 *
 * The market is part of the route rather than a query parameter, so unlike
 * `/orders` this endpoint takes no `market` argument.
 *
 * Like the rest of the kala API, business failures arrive as `200 OK` with
 * `isSuccessful: false`, so the envelope decides success rather than the status.
 */
@Service()
export class PortfolioService extends BaseService {
	getDepositPortfolio(): Observable<DepositPortfolioResponse[]> {
		return this.http
			.get<KalaApiResponse<DepositPortfolioResponse[]>>(`${this.kalaApiPath}/portfolios/deposit`)
			.pipe(
				map(response => {
					if (!response.isSuccessful) {
						throw new Error(response.error?.message ?? 'Failed to load portfolio');
					}

					return response.data ?? [];
				})
			);
	}
}
